<template>
  <div class="booking-form__sender">
    <div class="container-fluid">
      <div class="row">
        <div class="col customer-type">
          <h3 class="label text-md">
            Sender
            <tool-tip
              text="Sender is the person or company who supplies the commodity to be shipped."
            />
          </h3>
        </div>
      </div>
      <div v-if="shipper" class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label for="name" class="label">Name</label>
            <input
              type="text"
              class="input"
              placeholder="Enter Name"
              v-model="shipper.contactName"
            />
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <label class="label">Email</label>
            <input
              type="email"
              class="input"
              placeholder="Enter email"
              v-model="shipper.email"
              @blur="isValidEmail"
            />
            <p v-if="!isValidShipperEmail" class="text-danger text-sm">
              Please enter a valid email!
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Phone Number</label>
              <div class="flex">
                <label class="radio-label" for="mobile">
                  <input
                    type="radio"
                    name="mobiletype"
                    id="mobile"
                    value="mobile"
                    v-model="phoneNumberType"
                  />
                  Mobile
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="fixed">
                  <input
                    type="radio"
                    id="fixed"
                    name="mobiletype"
                    value="fixed"
                    v-model="phoneNumberType"
                  />
                  Fixed
                  <span></span>
                </label>
              </div>
            </div>
            <div class="">
              <vue-tel-input
                :preferredCountries="['Nigeria']"
                v-model="shipper.mobile"
              ></vue-tel-input>
              <div v-if="isValidPhone && shipper.mobile.length > 0">
                <p class="text-red-600">
                  Phone number must be numeric values only
                </p>
              </div>
              <div v-if="isValidPhoneLength && shipper.mobile.length > 0">
                <p class="text-red-600">
                  Phone number must be 11 characters long
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12 col-lg-6">
          <div class="input-wrapper">
            <div class="flex justify-between">
              <label class="label">Address</label>

              <div class="flex">
                <label class="radio-label" for="residential">
                  <input
                    type="radio"
                    id="residential"
                    value="residential"
                    v-model="addressType"
                  />
                  Residential
                  <span></span>
                </label>
                <label class="radio-label ml-4" for="business">
                  <input
                    type="radio"
                    id="business"
                    value="business"
                    v-model="addressType"
                  />
                  Business
                  <span></span>
                </label>
              </div>
            </div>
            <vue-google-autocomplete
              id="map2"
              ref="shipperAddress"
              :value="address.name"
              classname="input"
              placeholder="Enter address"
              :country="'ng'"
              v-on:placechanged="getAddress"
            >
            </vue-google-autocomplete>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="input-wrapper" style="width: 95%">
            <base-checkbox
              v-model="shipper.sendShippingUpdates"
              label="Send me status updates regarding my shipment with the email provided."
            />
          </div>
        </div>
      </div>
      <div class="button-wrapper">
        <p class="mt-4 cursor-pointer underline" @click="$router.go(-1)">
          Cancel
        </p>
        <span class="mr-6">
          <base-button
            text="Continue"
            :loading="isLoading"
            @click="handleSubmit"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
export default {
  name: "shipper-form",
  components: {
    VueGoogleAutocomplete,
  },
  data() {
    return {
      shipper: {
        email: "",
        mobile: "",
        type: "takeoff",
        country: "",
        contactName: "",
        address: "",
        sendShippingUpdates: false,
      },
      address: {
        name: "",
        lat: 0.0,
        lng: 0.0,
      },
      addressType: "business",
      phoneNumberType: "mobile",
      countries: ["Nigeria"],
      isValidShipperNumber: true,
      isLoading: false,
      isValidShipperEmail: true,
      hasCity: true,
      hasState: true,
    };
  },
  watch: {
    "shipper.customerType"(val) {
      if (val == "business") {
        this.addressType = "business";
      } else {
        this.addressType = "residential";
      }
    },

    "shipper.mobile"(val) {
      if (val?.length <= 12) {
        this.shipper.mobile = val;
      } else {
        this.shipper.mobile = val.trim().substring(0, 13);
      }
    },
    "$store.state.bookingModule.lastCompletedFormNo"() {
      if (this.$store.getters.shipperInformation.id.length > 0) {
        this.shipper = { ...this.$store.getters.shipperInformation };
      }
    },
    shipper: {
      handler: function () {
        this.mustUpdate = true;
      },
      deep: true,
    },
  },
  mounted() {
    this.shipper = {
      ...this.$store.getters.shipperInformation,
    };

    this.$refs.shipperAddress.update(this.formatAddress(this.shipper.address));
    this.address = this.shipper.address;

    if (this.$store.getters.shiperLocationPreselected) {
      this.shipper = {
        ...this.$store.getters.shipperInformation,
      };
      this.$refs.shipperAddress.update(
        this.formatAddress(this.shipper.address)
      );

      delete this.shipper.userId;
      delete this.shipper.type;
      delete this.shipper.updatedAt;
      delete this.shipper.createdAt;
    }
  },
  computed: {
    isValidPhone() {
      let phone = this.shipper.mobile;
      var patt = /[a-z]+/i;

      return patt.test(phone);
    },
    isValidPhoneLength() {
      return this.shipper.mobile.replace(/\s+/g, "").length != 11
        ? true
        : false;
    },
  },
  methods: {
    formLoaded(event) {
      event;
      this.$emit("change-form");
    },
    handleSubmit() {
      if (this.shipper.id && !this.mustUpdate) {
        this.mustUpdate = false;
      } else {
        this.submitShipperInformation();
      }
    },
    async submitShipperInformation() {
      if (!this.$store.getters.shipperLocationPreselected) {
        this.shipper.address = this.address;
      }
      try {
        this.isLoading = true;
        let payload = {
          contactName: this.shipper.contactName,
          email: this.shipper.email,
          mobile: this.shipper.mobile,
          customerType: this.shipper.customerType,
          type: this.shipper.type,
          address: this.shipper.address,
          zipCode: this.shipper.zipCode,
          sendShippingUpdates: this.shipper.sendShippingUpdates,
          mobileNumberType: this.shipper.mobileNumberType,
          addressType: this.shipper.addressType,
        };
        console.log(JSON.stringify(payload, null, 2));
        const response = await this.$_submitShipperInformation(payload);
        this.isLoading = false;
        console.log(JSON.stringify(response, null, 2));
        this.handleResponse(response);
      } catch (error) {
        this.handleError(error);
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    handleResponse(response) {
      this.isLoading = false;

      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: response.data.data.location,
      });
      this.shipper = response.data.data.location;
      this.mustUpdate = false;
      this.$store.dispatch(
        "saveTakeOffLocationId",
        response.data.data.location.id
      );
      this.$store.dispatch("saveLastCompletedFormNo", 1);
      this.isLoading = false;
      this.showModal = true;

      this.$emit("change-form");
    },

    getAddress(addressData) {
      this.address.name = addressData.route;
      this.address.lat = addressData.latitude;
      this.address.lng = addressData.longitude;
      this.shipper.country = addressData.country;
    },
    isValidEmail() {
      this.isValidShipperEmail = this.validateEmail(this.shipper.email);
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-form__sender {
  padding: 2rem 2.5rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.check-label {
  font-size: 0.9rem;
}

.input,
.vti__input,
.vue-tel-input {
  background: #fbfcfe;
  border: 1px solid #dae8f6;
  box-sizing: border-box;
  border-radius: 2px;
  height: 2.65rem !important;
}

.input::placeholder {
  color: #bec4d5;
}

.customer-type {
  margin: 1rem 1.5rem;
}

.input-wrapper {
  width: 90%;
  margin: 0 auto 2rem;
}

.customer-type h3 {
  font-size: 1.2rem;
}

// .button {
//   background-color: #fcc210;
//   color: var(--primaryblue);
//   border: 1px solid #fcc008;
//   box-sizing: border-box;
//   box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
//   border-radius: 2px;
//   margin-right: 1.5rem;
// }
.radio-label span::after {
  background: #bec4d5;
}
</style>
